'use client';

import React from 'react';
import type { ChatThinkingIndicatorProps } from './types';

const ChatThinkingIndicator: React.FC<ChatThinkingIndicatorProps> = ({
  'aria-label': ariaLabel = 'AI is thinking',
  'data-testid': testId = 'chat-thinking-indicator',
}) => (
  <div
    className="inline-flex items-center gap-1 rounded-2xl rounded-tl-sm bg-white border border-neutral-200 px-4 py-3 self-start"
    aria-label={ariaLabel}
    aria-live="polite"
    role="status"
    data-testid={testId}
  >
    <span className="w-2 h-2 rounded-full bg-neutral-300 animate-thinking-dot" />
    <span className="w-2 h-2 rounded-full bg-neutral-300 animate-thinking-dot [animation-delay:150ms]" />
    <span className="w-2 h-2 rounded-full bg-neutral-300 animate-thinking-dot [animation-delay:300ms]" />
  </div>
);

export default ChatThinkingIndicator;
